import { withInstall } from '@tw-element/utils'

import Affix from './src/affix.vue'

export const TwAffix = withInstall(Affix)
export default TwAffix

export * from './src/affix'
